// Мелочи для работы со страницей: поиск элементов, экранирование, сообщение внизу, «загружается».

export function $<T extends Element = HTMLElement>(sel: string, root: ParentNode = document): T {
  return root.querySelector(sel) as T;
}

export function $$<T extends Element = HTMLElement>(sel: string, root: ParentNode = document): T[] {
  return Array.from(root.querySelectorAll(sel)) as T[];
}

const ESC: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function esc(s: unknown): string {
  return String(s === null || s === undefined ? '' : s).replace(/[&<>"']/g, (c) => ESC[c] ?? c);
}

export function el(html: string): HTMLElement {
  const t = document.createElement('template');
  t.innerHTML = html.trim();
  return t.content.firstChild as HTMLElement;
}

let toastTimer: ReturnType<typeof setTimeout> | undefined;

export function toast(msg: string, err = false): void {
  const t = $('#toast');
  t.textContent = msg;
  t.className = err ? 'err' : '';
  t.hidden = false;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => { t.hidden = true; }, err ? 5000 : 2500);
}

export function busy(on: boolean): void {
  let b = document.querySelector('.busy');
  if (on && !b) {
    b = el('<div class="busy"><div class="spin"></div></div>');
    document.body.appendChild(b);
  } else if (!on && b) b.remove();
}

export function cap(s: string): string {
  const t = String(s || '');
  return t.charAt(0).toUpperCase() + t.slice(1);
}

export function copyText(t: string): void {
  try {
    void navigator.clipboard.writeText(t).then(() => toast('Скопировано'));
  } catch {
    const ta = document.createElement('textarea');
    ta.value = t;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    ta.remove();
    toast('Скопировано');
  }
}

export function store(key: string, value?: string): string | null {
  try {
    if (value === undefined) return localStorage.getItem(key);
    localStorage.setItem(key, value);
  } catch { /* закрытое хранилище — не страшно */ }
  return null;
}
